<template>
  <modal
    v-if="visible"
    :visible="visible"
    @click-outside-modal="$emit('close')"
  >
    <div class="tablet flex justify-center px-4">
      <div
        class="relative flex w-full flex-col items-start rounded bg-white p-6"
      >
        <img
          class="absolute right-4 top-4 h-4 w-4"
          src="@/assets/close-icon.svg"
          alt="cose icon"
          @click="$emit('close')"
        />
        <h3 class="header-text">Are you sure?</h3>
        <p class="mb-4 text-left text-body-color">
          Are you sure you want to delete this
          <span class="font-semibold">{{ contactType }}</span> contact?
          <span class="block font-semibold text-red-600"
            >This action cannot be undone.</span
          >
        </p>
        <div
          class="mb-8 flex w-full items-center gap-8 rounded-md border-2 border-red-600 bg-red-50 px-4 py-4 text-red-600"
        >
          <div
            class="flex h-full flex-col items-center justify-center gap-0 py-0"
          >
            <div
              v-if="contactToDelete?.is_type == 'dispatch'"
              class="flex h-full flex-col items-center justify-center gap-0 py-0"
            >
              <svg
                class="h-auto w-8"
                viewBox="0 0 47 50"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_9_152)">
                  <path
                    d="M39.36 20.54C40.34 22.82 40.5 24.92 40.5 27.56C40.5 37.93 32.09 46.34 21.72 46.34C11.35 46.34 2.94 37.93 2.94 27.56C2.94 17.19 11.35 8.77 21.72 8.77C23.33 8.77 24.4 8.92 25.89 9.3L25.35 6.16C23.85 5.83 23.32 5.84 21.73 5.84C9.73 5.83 0 15.56 0 27.56C0 39.56 9.73 49.28 21.72 49.28C33.71 49.28 43.49 39.72 43.44 27.56C43.43 24.96 43.46 22.93 42.53 20.67L39.36 20.55V20.54Z"
                    fill="currentColor"
                  />
                  <path
                    d="M21.71 28.94C17.85 28.94 14.71 25.8 14.71 21.94C14.71 18.08 17.85 14.94 21.71 14.94C25.57 14.94 28.71 18.08 28.71 21.94C28.71 25.8 25.57 28.94 21.71 28.94ZM21.71 17.94C19.5 17.94 17.71 19.73 17.71 21.94C17.71 24.15 19.5 25.94 21.71 25.94C23.92 25.94 25.71 24.15 25.71 21.94C25.71 19.73 23.92 17.94 21.71 17.94Z"
                    fill="currentColor"
                  />
                  <path
                    d="M34.92 44.7L32.33 43.19C33.39 41.37 33.4 39.19 32.35 37.36C31.3 35.53 29.42 34.44 27.31 34.44H16.11C14 34.44 12.12 35.53 11.07 37.36C10.02 39.19 10.03 41.37 11.09 43.19L8.5 44.7C6.89 41.94 6.88 38.64 8.47 35.87C10.06 33.1 12.92 31.45 16.11 31.45H27.31C30.5 31.45 33.36 33.1 34.95 35.87C36.54 38.64 36.53 41.94 34.92 44.7Z"
                    fill="currentColor"
                  />
                  <path
                    d="M42.86 18.93H41.96C33.76 18.93 27.09 12.26 27.09 4.06V3.16C27.09 2.32 27.42 1.53 28.01 0.93C28.6 0.33 29.4 0.01 30.24 0.01H33.2C33.68 0.01 34.13 0.16 34.52 0.44C34.9 0.71 35.19 1.1 35.34 1.55L36.69 5.61C36.86 6.12 36.84 6.68 36.64 7.18C36.43 7.68 36.05 8.09 35.56 8.34L34.78 8.73C35.44 9.74 36.3 10.61 37.31 11.26L37.7 10.48C37.94 10 38.35 9.62 38.85 9.41C39.35 9.2 39.91 9.18 40.42 9.35L44.47 10.7C44.92 10.85 45.31 11.14 45.59 11.52C45.87 11.9 46.01 12.36 46.01 12.83V15.79C46.01 16.63 45.68 17.42 45.09 18.02C44.49 18.62 43.7 18.94 42.86 18.94V18.93ZM30.23 2.7C30.11 2.7 30 2.75 29.91 2.83C29.83 2.91 29.78 3.03 29.78 3.15V4.05C29.78 10.76 35.24 16.22 41.95 16.22H42.85C42.97 16.22 43.08 16.17 43.17 16.09C43.25 16.01 43.3 15.89 43.3 15.77V13.14L39.93 12.02L39.09 13.71C38.76 14.36 37.99 14.64 37.32 14.34C34.81 13.21 32.81 11.2 31.67 8.69C31.37 8.03 31.65 7.25 32.3 6.92L33.99 6.08L32.87 2.71H30.24L30.23 2.7ZM39.25 8.11C38.9 8.11 38.56 7.98 38.29 7.71C37.76 7.18 37.76 6.33 38.29 5.8L41.39 2.7H40.15C39.4 2.7 38.8 2.09 38.8 1.35C38.8 0.61 39.41 0 40.15 0H44.65C44.65 0 44.66 0 44.67 0C44.85 0 45.01 0.04 45.17 0.1C45.32 0.16 45.47 0.26 45.6 0.38L45.62 0.41C45.74 0.54 45.84 0.68 45.9 0.84C45.96 0.99 46 1.16 46 1.34V5.86C46 6.61 45.39 7.21 44.65 7.21C43.91 7.21 43.3 6.6 43.3 5.86V4.62L40.2 7.72C39.94 7.98 39.59 8.12 39.24 8.12L39.25 8.11Z"
                    fill="currentColor"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_9_152">
                    <rect
                      width="46.01"
                      height="49.28"
                      fill="white"
                    />
                  </clipPath>
                </defs>
              </svg>
              <div class="relative text-center text-xs font-semibold uppercase">
                <span class="block">Dispatch</span>
              </div>
            </div>
            <div
              v-else-if="contactToDelete?.is_type == 'billing'"
              class="flex h-full flex-col items-center justify-center gap-0 py-0"
            >
              <svg
                class="h-auto w-8"
                viewBox="0 0 50 49"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_9_170)">
                  <path
                    d="M21.71 24.12C17.85 24.12 14.71 20.98 14.71 17.12C14.71 13.26 17.85 10.12 21.71 10.12C25.57 10.12 28.71 13.26 28.71 17.12C28.71 20.98 25.57 24.12 21.71 24.12ZM21.71 13.12C19.5 13.12 17.71 14.91 17.71 17.12C17.71 19.33 19.5 21.12 21.71 21.12C23.92 21.12 25.71 19.33 25.71 17.12C25.71 14.91 23.92 13.12 21.71 13.12Z"
                    fill="currentColor"
                  />
                  <path
                    d="M30.54 30.17C29.58 29.48 28.56 29.62 27.31 29.62H16.11C14 29.62 12.12 30.71 11.07 32.54C10.02 34.37 10.03 36.55 11.09 38.37L8.5 39.88C6.89 37.12 6.88 33.82 8.47 31.05C10.06 28.28 12.92 26.63 16.11 26.63H27.31C30.25 26.63 33.5 27.49 34.55 30.17C34.55 30.17 34.42 29.95 34.55 30.17H30.55H30.54Z"
                    fill="currentColor"
                  />
                  <path
                    d="M44.54 48.13H32.54C31.47 48.13 30.47 47.71 29.71 46.96C28.95 46.2 28.54 45.2 28.54 44.13V36.13C28.54 35.06 28.96 34.06 29.71 33.3C30.47 32.54 31.47 32.13 32.54 32.13H44.54C45.61 32.13 46.61 32.55 47.37 33.3C48.13 34.06 48.54 35.06 48.54 36.13V44.13C48.54 45.2 48.12 46.2 47.37 46.96C46.61 47.72 45.61 48.13 44.54 48.13ZM30.54 39.13V44.13C30.54 44.66 30.75 45.17 31.13 45.54C31.51 45.92 32.01 46.13 32.54 46.13H44.54C45.07 46.13 45.58 45.92 45.95 45.54C46.32 45.16 46.54 44.65 46.54 44.13V39.13H30.54ZM30.54 37.13H46.54V36.13C46.54 35.6 46.33 35.09 45.95 34.72C45.58 34.35 45.06 34.13 44.54 34.13H32.54C32.01 34.13 31.5 34.34 31.13 34.72C30.76 35.1 30.54 35.6 30.54 36.13V37.13ZM39.54 44.13H38.54C37.99 44.13 37.54 43.68 37.54 43.13C37.54 42.58 37.99 42.13 38.54 42.13H39.54C40.09 42.13 40.54 42.58 40.54 43.13C40.54 43.68 40.09 44.13 39.54 44.13ZM34.54 44.13H33.54C32.99 44.13 32.54 43.68 32.54 43.13C32.54 42.58 32.99 42.13 33.54 42.13H34.54C35.09 42.13 35.54 42.58 35.54 43.13C35.54 43.68 35.09 44.13 34.54 44.13Z"
                    fill="currentColor"
                  />
                  <path
                    d="M2.94 22.73C2.94 12.36 11.35 3.95 21.72 3.95C23.85 3.95 25.88 4.32 27.79 4.97C27.9 4.77 28.03 4.58 28.2 4.41C28.67 3.94 29.3 3.68 29.96 3.68H32.18C29.08 1.97 25.51 1 21.72 1C9.73 1.01 0 10.74 0 22.73C0 34.72 9.73 44.45 21.72 44.45C23.32 44.45 24.87 44.27 26.37 43.94V40.9C24.88 41.28 23.33 41.5 21.72 41.5C11.35 41.5 2.94 33.09 2.94 22.72V22.73Z"
                    fill="currentColor"
                  />
                  <path
                    d="M40.36 14.1C40.36 14.76 40.1 15.39 39.63 15.86C39.52 15.97 39.41 16.06 39.28 16.14C40.05 18.19 40.49 20.41 40.49 22.73C40.49 25.37 39.94 27.88 38.96 30.15H42.1C42.94 27.83 43.43 25.34 43.43 22.73C43.43 18.65 42.3 14.84 40.35 11.57V14.09L40.36 14.1Z"
                    fill="currentColor"
                  />
                  <path
                    d="M45.13 48.18H32.82C31.66 48.18 30.52 47.71 29.69 46.88C28.86 46.05 28.39 44.93 28.39 43.75V35.54C28.39 34.36 28.85 33.25 29.69 32.41C30.53 31.57 31.65 31.11 32.82 31.11H45.13C46.31 31.11 47.42 31.57 48.26 32.41C49.1 33.25 49.56 34.36 49.56 35.54V43.75C49.56 44.93 49.1 46.04 48.26 46.88C47.42 47.72 46.31 48.18 45.13 48.18ZM31.08 38.94V43.75C31.08 44.21 31.27 44.65 31.59 44.98C31.91 45.3 32.36 45.49 32.82 45.49H45.13C45.59 45.49 46.03 45.31 46.36 44.98C46.68 44.66 46.87 44.21 46.87 43.75V38.94H31.09H31.08ZM31.08 36.25H46.86V35.54C46.86 35.08 46.67 34.64 46.35 34.31C46.02 33.98 45.59 33.8 45.12 33.8H32.81C32.35 33.8 31.91 33.99 31.58 34.31C31.26 34.63 31.07 35.08 31.07 35.54V36.25H31.08ZM40 44.07H38.97C38.23 44.07 37.63 43.47 37.63 42.73C37.63 41.99 38.23 41.39 38.97 41.39H40C40.74 41.39 41.34 41.99 41.34 42.73C41.34 43.47 40.74 44.07 40 44.07ZM34.87 44.07H33.84C33.1 44.07 32.5 43.47 32.5 42.73C32.5 41.99 33.1 41.39 33.84 41.39H34.87C35.61 41.39 36.21 41.99 36.21 42.73C36.21 43.47 35.61 44.07 34.87 44.07Z"
                    fill="currentColor"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M36.29 0C36.7 0 37.1 0.16 37.39 0.46C37.68 0.75 37.85 1.15 37.85 1.56V4.85H41.14C41.55 4.85 41.95 5.01 42.24 5.31C42.53 5.6 42.7 6 42.7 6.41C42.7 6.82 42.54 7.22 42.24 7.51C41.94 7.8 41.55 7.97 41.14 7.97H37.85V11.26C37.85 11.67 37.69 12.07 37.39 12.36C37.09 12.65 36.7 12.82 36.29 12.82C35.88 12.82 35.48 12.66 35.19 12.36C34.9 12.07 34.73 11.67 34.73 11.26V7.97H31.44C31.03 7.97 30.63 7.81 30.34 7.51C30.05 7.22 29.88 6.82 29.88 6.41C29.88 6 30.04 5.6 30.34 5.31C30.63 5.02 31.03 4.85 31.44 4.85H34.73V1.56C34.73 1.15 34.89 0.75 35.19 0.46C35.48 0.17 35.88 0 36.29 0V0Z"
                    fill="currentColor"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_9_170">
                    <rect
                      width="49.55"
                      height="48.18"
                      fill="white"
                    />
                  </clipPath>
                </defs>
              </svg>
              <div class="relative text-center text-xs font-semibold uppercase">
                <span class="block">Billing</span>
              </div>
            </div>
            <div
              v-else-if="contactToDelete?.is_type == 'claims'"
              class="flex h-full flex-col items-center justify-center gap-0 py-0"
            >
              <svg
                class="h-auto w-8"
                viewBox="0 0 48 51"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M38.97 21.05C39.95 23.33 40.5 25.84 40.5 28.47C40.5 38.84 32.09 47.25 21.72 47.25C11.35 47.25 2.94 38.85 2.94 28.48C2.94 18.11 11.35 9.7 21.72 9.7C23.33 9.7 24.88 9.92 26.37 10.3L26.05 7.2C24.55 6.87 23.32 6.76 21.72 6.76C9.73 6.75 0 16.48 0 28.48C0 40.48 9.73 50.2 21.72 50.2C33.71 50.2 43.44 40.47 43.44 28.48C43.44 25.87 42.96 22.14 41.87 19.91L38.97 21.06V21.05Z"
                  fill="currentColor"
                />
                <path
                  d="M21.71 29.87C17.85 29.87 14.71 26.73 14.71 22.87C14.71 19.01 17.85 15.87 21.71 15.87C25.57 15.87 28.71 19.01 28.71 22.87C28.71 26.73 25.57 29.87 21.71 29.87ZM21.71 18.87C19.5 18.87 17.71 20.66 17.71 22.87C17.71 25.08 19.5 26.87 21.71 26.87C23.92 26.87 25.71 25.08 25.71 22.87C25.71 20.66 23.92 18.87 21.71 18.87Z"
                  fill="currentColor"
                />
                <path
                  d="M34.92 45.62L32.33 44.11C33.39 42.29 33.4 40.11 32.35 38.28C31.3 36.45 29.42 35.36 27.31 35.36H16.11C14 35.36 12.12 36.45 11.07 38.28C10.02 40.11 10.03 42.29 11.09 44.11L8.5 45.62C6.89 42.86 6.88 39.56 8.47 36.79C10.06 34.02 12.92 32.37 16.11 32.37H27.31C30.5 32.37 33.36 34.02 34.95 36.79C36.54 39.56 36.53 42.86 34.92 45.62Z"
                  fill="currentColor"
                />
                <path
                  d="M37.76 19.4C37.64 19.4 37.52 19.39 37.41 19.36C31.82 17.92 27.91 12.88 27.91 7.09C27.91 6.01 28.05 4.94 28.31 3.91C28.48 3.26 29.12 2.82 29.75 2.86C32.36 3 34.87 2.11 36.82 0.370002C37.36 -0.109998 38.16 -0.109998 38.7 0.370002C40.65 2.12 43.15 3.01 45.77 2.86C46.42 2.82 47.04 3.26 47.21 3.91C47.48 4.94 47.61 6.01 47.61 7.09C47.61 12.87 43.7 17.92 38.11 19.36C37.99 19.39 37.88 19.4 37.76 19.4V19.4ZM30.83 5.67C30.76 6.14 30.73 6.61 30.73 7.09C30.73 11.47 33.6 15.3 37.77 16.53C41.93 15.3 44.81 11.46 44.81 7.09C44.81 6.61 44.78 6.14 44.71 5.67C42.2 5.56 39.8 4.72 37.77 3.22C35.75 4.72 33.35 5.56 30.84 5.67H30.83ZM37.77 14.12C36.99 14.12 36.36 13.49 36.36 12.71C36.36 11.93 36.99 11.3 37.76 11.3H37.77C38.55 11.3 39.18 11.93 39.18 12.71C39.18 13.49 38.55 14.12 37.77 14.12ZM37.76 10.37C36.98 10.37 36.35 9.74 36.35 8.96V7.08C36.35 6.3 36.98 5.67 37.76 5.67C38.54 5.67 39.17 6.3 39.17 7.08V8.96C39.17 9.74 38.54 10.37 37.76 10.37Z"
                  fill="currentColor"
                />
              </svg>
              <div class="relative text-center text-xs font-semibold uppercase">
                <span class="block">Claims</span>
              </div>
            </div>
            <div
              v-else-if="contactToDelete?.is_type == 'after_hours'"
              class="flex h-full flex-col items-center justify-center gap-0 py-0"
            >
              <svg
                class="h-auto w-8"
                viewBox="0 0 49 53"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M38.97 23.75C39.95 26.03 40.5 28.54 40.5 31.17C40.5 41.54 32.09 49.95 21.72 49.95C11.35 49.95 2.94 41.54 2.94 31.17C2.94 20.8 11.35 12.39 21.72 12.39C23.33 12.39 24.88 12.61 26.37 12.99L26.05 9.89C24.55 9.56 23.32 9.45 21.72 9.45C9.72 9.45 0 19.18 0 31.17C0 43.16 9.73 52.89 21.72 52.89C33.71 52.89 43.44 43.16 43.44 31.17C43.44 28.56 42.96 24.83 41.87 22.6L38.97 23.75V23.75Z"
                  fill="currentColor"
                />
                <path
                  d="M21.71 32.56C17.85 32.56 14.71 29.42 14.71 25.56C14.71 21.7 17.85 18.56 21.71 18.56C25.57 18.56 28.71 21.7 28.71 25.56C28.71 29.42 25.57 32.56 21.71 32.56ZM21.71 21.56C19.5 21.56 17.71 23.35 17.71 25.56C17.71 27.77 19.5 29.56 21.71 29.56C23.92 29.56 25.71 27.77 25.71 25.56C25.71 23.35 23.92 21.56 21.71 21.56Z"
                  fill="currentColor"
                />
                <path
                  d="M34.92 48.32L32.33 46.81C33.39 44.99 33.4 42.81 32.35 40.98C31.3 39.15 29.42 38.06 27.31 38.06H16.11C14 38.06 12.12 39.15 11.07 40.98C10.02 42.81 10.03 44.99 11.09 46.81L8.5 48.32C6.89 45.56 6.88 42.26 8.47 39.49C10.06 36.72 12.92 35.07 16.11 35.07H27.31C30.5 35.07 33.36 36.72 34.95 39.49C36.54 42.26 36.53 45.56 34.92 48.32Z"
                  fill="currentColor"
                />
                <path
                  d="M38.46 22.08C32.39 22.08 27.46 17.15 27.46 11.08C27.46 6.63 30.12 2.64 34.23 0.919997C34.7 0.729997 35.24 0.830002 35.6 1.19C35.96 1.55 36.06 2.09 35.87 2.55C35.44 3.59 35.22 4.69 35.22 5.82C35.22 10.51 39.03 14.32 43.72 14.32C44.85 14.32 45.95 14.1 46.99 13.67C47.46 13.47 48 13.58 48.36 13.94C48.72 14.3 48.82 14.84 48.63 15.31C46.92 19.42 42.93 22.08 38.47 22.08H38.46ZM32.76 4.77C31.01 6.35 29.96 8.62 29.96 11.08C29.96 15.77 33.77 19.58 38.46 19.58C40.92 19.58 43.19 18.53 44.77 16.78C44.42 16.81 44.06 16.83 43.71 16.83C37.64 16.83 32.71 11.9 32.71 5.83C32.71 5.47 32.73 5.12 32.76 4.77V4.77Z"
                  fill="currentColor"
                />
              </svg>
              <div class="relative text-center text-xs font-semibold uppercase">
                <span class="block">After Hours</span>
              </div>
            </div>
            <div
              v-else-if="contactToDelete?.is_type == 'emergency'"
              class="flex h-full flex-col items-center justify-center gap-0 py-0"
            >
              <svg
                class="h-auto w-8"
                viewBox="0 0 48 52"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M38.97 21.97C39.95 24.25 40.5 26.76 40.5 29.39C40.5 39.76 32.09 48.17 21.72 48.17C11.35 48.17 2.94 39.76 2.94 29.39C2.94 19.02 11.35 10.61 21.72 10.61C23.33 10.61 24.88 10.83 26.37 11.21L27.83 8.77L26.05 8.11C24.55 7.78 23.32 7.67 21.72 7.67C9.72 7.67 0 17.4 0 29.39C0 41.38 9.73 51.11 21.72 51.11C33.71 51.11 43.44 41.38 43.44 29.39C43.44 26.78 42.96 23.05 41.87 20.82L38.4 20.85L38.97 21.97Z"
                  fill="currentColor"
                />
                <path
                  d="M21.71 30.78C17.85 30.78 14.71 27.64 14.71 23.78C14.71 19.92 17.85 16.78 21.71 16.78C25.57 16.78 28.71 19.92 28.71 23.78C28.71 27.64 25.57 30.78 21.71 30.78ZM21.71 19.78C19.5 19.78 17.71 21.57 17.71 23.78C17.71 25.99 19.5 27.78 21.71 27.78C23.92 27.78 25.71 25.99 25.71 23.78C25.71 21.57 23.92 19.78 21.71 19.78Z"
                  fill="currentColor"
                />
                <path
                  d="M34.92 46.53L32.33 45.02C33.39 43.2 33.4 41.02 32.35 39.19C31.3 37.36 29.42 36.27 27.31 36.27H16.11C14 36.27 12.12 37.36 11.07 39.19C10.02 41.02 10.03 43.2 11.09 45.02L8.5 46.53C6.89 43.77 6.88 40.47 8.47 37.7C10.06 34.93 12.92 33.28 16.11 33.28H27.31C30.5 33.28 33.36 34.93 34.95 37.7C36.54 40.47 36.53 43.77 34.92 46.53Z"
                  fill="currentColor"
                />
                <path
                  d="M44.13 18.81H30.8C29.61 18.81 28.55 18.2 27.95 17.17C27.35 16.14 27.36 14.91 27.95 13.88L34.62 2.33C35.21 1.3 36.28 0.679993 37.47 0.679993C38.66 0.679993 39.72 1.29 40.32 2.33L46.99 13.88C47.58 14.91 47.58 16.14 46.99 17.17C46.4 18.2 45.33 18.81 44.14 18.81H44.13ZM30.12 15.13C29.91 15.49 30.05 15.8 30.12 15.92C30.19 16.04 30.39 16.31 30.8 16.31H44.13C44.54 16.31 44.75 16.03 44.81 15.92C44.87 15.81 45.02 15.49 44.81 15.13L38.15 3.58C37.94 3.22 37.6 3.19 37.47 3.19C37.34 3.19 36.99 3.23 36.79 3.58L30.12 15.13ZM37.47 15.42C36.78 15.42 36.21 14.86 36.21 14.17C36.21 13.48 36.77 12.91 37.46 12.91C38.15 12.91 38.71 13.47 38.71 14.16C38.71 14.85 38.15 15.42 37.46 15.42H37.47ZM37.47 12.25C36.78 12.25 36.22 11.73 36.22 11.09V7.95C36.22 7.31 36.78 6.78999 37.47 6.78999C38.16 6.78999 38.72 7.31 38.72 7.95V11.09C38.72 11.73 38.16 12.25 37.47 12.25Z"
                  fill="currentColor"
                />
              </svg>
              <div class="relative text-center text-xs font-semibold uppercase">
                <span class="block">Emergency</span>
              </div>
            </div>
            <div
              v-else-if="contactToDelete?.is_type == 'owner'"
              class="flex h-full flex-col items-center justify-center gap-0 py-0"
            >
              <svg
                class="h-auto w-8"
                viewBox="0 0 47 50"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M39.57 19.97C40.55 22.25 41.1 24.76 41.1 27.39C41.1 37.76 32.69 46.17 22.32 46.17C11.95 46.17 3.54001 37.76 3.54001 27.39C3.54001 17.02 11.95 8.60999 22.32 8.60999C23.93 8.60999 24.3 8.57001 25.79 8.95001L26.65 6.10999C25.15 5.77999 23.92 5.67001 22.32 5.67001C10.32 5.67001 0.600006 15.4 0.600006 27.39C0.600006 39.38 10.33 49.11 22.32 49.11C34.31 49.11 44.04 39.38 44.04 27.39C44.04 24.78 43.56 21.05 42.47 18.82L39.57 19.97V19.97Z"
                  fill="currentColor"
                />
                <path
                  d="M22.31 28.78C18.45 28.78 15.31 25.64 15.31 21.78C15.31 17.92 18.45 14.78 22.31 14.78C26.17 14.78 29.31 17.92 29.31 21.78C29.31 25.64 26.17 28.78 22.31 28.78V28.78ZM22.31 17.78C20.1 17.78 18.31 19.57 18.31 21.78C18.31 23.99 20.1 25.78 22.31 25.78C24.52 25.78 26.31 23.99 26.31 21.78C26.31 19.57 24.52 17.78 22.31 17.78Z"
                  fill="currentColor"
                />
                <path
                  d="M35.52 44.53L32.93 43.02C33.99 41.2 34 39.02 32.95 37.19C31.9 35.36 30.02 34.27 27.91 34.27H16.71C14.6 34.27 12.72 35.36 11.67 37.19C10.62 39.02 10.63 41.2 11.69 43.02L9.10001 44.53C7.49001 41.77 7.48001 38.47 9.07001 35.7C10.66 32.93 13.52 31.28 16.71 31.28H27.91C31.1 31.28 33.96 32.93 35.55 35.7C37.14 38.47 37.13 41.77 35.52 44.53V44.53Z"
                  fill="currentColor"
                />
                <path
                  d="M36.74 19.02C35.49 19.02 34.3 18.51 33.43 17.63C32.22 17.63 30.99 17.16 30.11 16.27C29.22 15.39 28.74 14.18 28.75 12.95C27.87 12.09 27.36 10.89 27.36 9.64001C27.36 8.39001 27.87 7.19999 28.75 6.32999C28.74 5.09999 29.22 3.89001 30.11 3.01001C31 2.13001 32.25 1.63999 33.43 1.64999C34.29 0.769994 35.49 0.259995 36.74 0.259995C37.99 0.259995 39.18 0.769994 40.05 1.64999C41.29 1.64999 42.49 2.12001 43.37 3.01001C44.25 3.90001 44.74 5.09999 44.73 6.32999C45.61 7.18999 46.12 8.38001 46.12 9.64001C46.12 10.9 45.61 12.08 44.73 12.95C44.74 14.18 44.26 15.39 43.37 16.27C42.49 17.15 41.31 17.63 40.09 17.63H40.05C39.19 18.51 37.99 19.02 36.74 19.02ZM33.97 15.08C34.37 15.08 34.76 15.27 34.99 15.61C35.39 16.18 36.04 16.52 36.74 16.52C37.44 16.52 38.09 16.18 38.49 15.61C38.77 15.21 39.25 15.01 39.73 15.1C40.41 15.22 41.12 15 41.61 14.51C42.1 14.02 42.32 13.32 42.2 12.63C42.12 12.15 42.32 11.67 42.71 11.39C43.28 10.99 43.62 10.34 43.62 9.64001C43.62 8.94001 43.28 8.29001 42.71 7.89001C42.31 7.61001 42.12 7.12999 42.2 6.64999C42.32 5.96999 42.1 5.25999 41.61 4.76999C41.12 4.27999 40.42 4.05999 39.73 4.17999C39.25 4.26999 38.77 4.06001 38.49 3.67001C38.09 3.10001 37.44 2.76001 36.74 2.76001C36.04 2.76001 35.39 3.10001 34.99 3.67001C34.71 4.06001 34.23 4.26999 33.75 4.17999C33.07 4.05999 32.36 4.27999 31.87 4.76999C31.38 5.25999 31.16 5.95999 31.28 6.64999C31.36 7.12999 31.16 7.61001 30.77 7.89001C30.2 8.29001 29.86 8.94001 29.86 9.64001C29.86 10.34 30.2 10.99 30.77 11.39C31.17 11.67 31.36 12.15 31.28 12.63C31.16 13.32 31.38 14.02 31.87 14.51C32.36 15 33.06 15.22 33.75 15.1C33.82 15.09 33.89 15.08 33.96 15.08H33.97ZM36.06 13.6C35.73 13.6 35.41 13.47 35.18 13.23L33.15 11.2C32.66 10.71 32.66 9.91999 33.15 9.42999C33.64 8.93999 34.43 8.93999 34.92 9.42999L35.91 10.42L38.44 6.88C38.84 6.32 39.62 6.19 40.18 6.59C40.74 6.99 40.87 7.76999 40.47 8.32999L37.09 13.07C36.88 13.37 36.54 13.56 36.18 13.59C36.14 13.59 36.11 13.59 36.08 13.59L36.06 13.6Z"
                  fill="currentColor"
                />
              </svg>
              <div class="relative text-center text-xs font-semibold uppercase">
                <span class="block">Owner</span>
              </div>
            </div>
          </div>
          <div class="align-self-end flex flex-col gap-1 text-left text-xs">
            <div>
              <span class="inline-flex whitespace-nowrap">{{
                contactToDelete?.name
              }}</span>
            </div>
            <div>
              <span class="inline-flex whitespace-nowrap">{{
                contactToDelete?.phone?.value
              }}</span>
            </div>
            <div>
              <span class="inline-flex whitespace-nowrap">{{
                contactToDelete?.email_address?.value
              }}</span>
            </div>
          </div>
        </div>
        <div
          class="flex w-full flex-col md:ml-auto md:w-2/3 md:flex-row-reverse md:gap-x-2"
        >
          <button-main
            variant="warning"
            @click="$emit('delete', contactToDelete)"
          >
            Yes, delete
          </button-main>
          <button-main
            variant="secondary"
            class="mt-3 md:mt-0"
            @click="$emit('close')"
          >
            Cancel
          </button-main>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/modals/Modal.vue';
import ButtonMain from '@/components/Button.vue';

export default {
  name: 'ConfirmDeleteContactModal',
  components: {
    Modal,
    ButtonMain,
  },
  props: {
    visible: Boolean,
    contactType: String,
    subtext: {
      type: String,
      default:
        'Are you sure you want to delete this contact? This action cannot be undone.',
    },
  },
  emits: ['close', 'delete'],
  setup(_, { emit }) {
    const onCancel = () => {
      emit('close');
    };

    return {
      onCancel,
    };
  },
  computed: {
    contactToDelete() {
      return this.$store.state.contacts?.savedContacts[this.contactType];
    },
  },
};
</script>

<style scoped>
@media screen and (min-width: 768px) {
  .tablet {
    width: 500px;
  }
}

.header-text {
  font-size: 26px;
  @apply mb-4 text-dark-blue;
}
</style>
